/**
 * etapes-discussion.ts — Source unique des libellés des 5 étapes Discussion.
 * Les lettres C/R/E/D/O sont les clés internes (ne changent pas).
 * Les labels et sous-titres sont les noms affichés à l'utilisateur.
 */

export interface EtapeDiscussion {
  lettre: "C" | "R" | "E" | "D" | "O";
  cle: "objectif" | "situation" | "pistes" | "decisions" | "plan";
  numero: 1 | 2 | 3 | 4 | 5;
  label: string;
  sousTitre: string;
}

export const ETAPES_DISCUSSION: readonly EtapeDiscussion[] = [
  { lettre: "C", cle: "objectif",   numero: 1, label: "Objectif",       sousTitre: "La tension à résoudre" },
  { lettre: "R", cle: "situation",  numero: 2, label: "Situation",      sousTitre: "Faits, questions ouvertes, documents" },
  { lettre: "E", cle: "pistes",    numero: 3, label: "Pistes",         sousTitre: "Experts et avis" },
  { lettre: "D", cle: "decisions", numero: 4, label: "Décisions",      sousTitre: "Mettre les pistes à l'épreuve et trancher" },
  { lettre: "O", cle: "plan",     numero: 5, label: "Plan de match",   sousTitre: "Livrables, tâches, équipe" },
] as const;

/** Libellé indexé par lettre : { C: "Objectif", R: "Situation", … } */
export const ETAPE_LABEL: Record<string, string> = Object.fromEntries(
  ETAPES_DISCUSSION.map((e) => [e.lettre, e.label]),
);

/** Accepte la lettre (C/R/E/D/O) ou la clé (objectif/situation/…), insensible à la casse.
 *  Rend le label ou la valeur reçue si inconnue. */
export function labelEtape(lettreOuCle: string): string {
  const u = lettreOuCle.toUpperCase();
  const byLetter = ETAPES_DISCUSSION.find((e) => e.lettre === u);
  if (byLetter) return byLetter.label;
  const l = lettreOuCle.toLowerCase();
  const byKey = ETAPES_DISCUSSION.find((e) => e.cle === l);
  if (byKey) return byKey.label;
  return lettreOuCle;
}

/** Accepte la lettre ou la clé, rend le numéro (1-5) ou null si inconnu. */
export function numeroEtape(lettreOuCle: string): number | null {
  const u = lettreOuCle.toUpperCase();
  const byLetter = ETAPES_DISCUSSION.find((e) => e.lettre === u);
  if (byLetter) return byLetter.numero;
  const l = lettreOuCle.toLowerCase();
  const byKey = ETAPES_DISCUSSION.find((e) => e.cle === l);
  if (byKey) return byKey.numero;
  return null;
}
